type WizardRoute = 'contractor' | 'benchmark'
type FrameworkType = 'ep-rates' | 'sor' | 'quantity' | null

enum Steps {
  Route,
  Contractor,
  Service,
  Specification,
  Details,
  Historical,
  SorInput,
  QuantityInput,
  Results
}

type StepDef = { step: Steps; label: string }

const contractorSteps: StepDef[] = [
  { step: Steps.Route, label: 'Route' },
  { step: Steps.Contractor, label: 'Contractor' },
  { step: Steps.Service, label: 'Service' },
  { step: Steps.Specification, label: 'Specification' },
  { step: Steps.Details, label: 'Details' },
  { step: Steps.Historical, label: 'Historical' },
  { step: Steps.Results, label: 'Results' }
]

const benchmarkEpSteps: StepDef[] = [
  { step: Steps.Route, label: 'Route' },
  { step: Steps.Service, label: 'Service' },
  { step: Steps.Specification, label: 'Specification' },
  { step: Steps.Details, label: 'Details' },
  // Historical (captcha) step removed from the EP Rates flow (#19)
  { step: Steps.Results, label: 'Results' }
]

const benchmarkSorSteps: StepDef[] = [
  { step: Steps.Route, label: 'Route' },
  { step: Steps.Service, label: 'Service' },
  { step: Steps.SorInput, label: 'SOR Input' },
  { step: Steps.Results, label: 'Results' }
]

const benchmarkQuantitySteps: StepDef[] = [
  { step: Steps.Route, label: 'Route' },
  { step: Steps.Service, label: 'Service' },
  { step: Steps.QuantityInput, label: 'Quantities' },
  { step: Steps.Results, label: 'Results' }
]

function getStepsForRoute(route: WizardRoute, frameworkType?: FrameworkType): StepDef[] {
  if (route === 'contractor') return contractorSteps
  if (frameworkType === 'sor') return benchmarkSorSteps
  if (frameworkType === 'quantity') return benchmarkQuantitySteps
  return benchmarkEpSteps
}

function getStepIndex(route: WizardRoute, currentStep: Steps, frameworkType?: FrameworkType): number {
  const steps = getStepsForRoute(route, frameworkType)
  return steps.findIndex((s) => s.step === currentStep)
}

export { getStepsForRoute, getStepIndex, Steps }
export type { StepDef, WizardRoute, FrameworkType }
